export const VIEW_MARK = "VIEW_MARK";
export const GET_MARK = "GET_MARK";